module.exports = __webpack_public_path__ + "img/redbrick.8d995edd.png";